import { useTranslation } from 'react-i18next';

import { PrepaidMarketingContainer } from '@/components/Containers/PrepaidMarketingContainer';
import { MarketingProductsProps } from '@/components/Products/EmailMarketingProducts';

export const PrepaidProducts = ({
  onRequestInfo,
  onProductSelect,
  products,
  steps,
  userProducts,
  userIsLogged,
}: MarketingProductsProps) => {
  const { t } = useTranslation();
  const title = t('productTypes.prepaid.headerTitle');
  const marks = steps;
  const max = Object.keys(marks).length - 1;

  const onSliderChange = () => {};

  return (
    <PrepaidMarketingContainer
      title={title}
      products={products}
      max={max}
      onSliderChange={onSliderChange}
      onProductSelect={onProductSelect}
      onRequestInfo={onRequestInfo}
      marks={marks}
      selectMarks={marks}
      userProducts={userProducts}
      userIsLogged={userIsLogged}
    />
  );
};
